module["exports"] = [
  "#### ??"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/address/postcode.js
 ** module id = 880
 ** module chunks = 0
 **/